module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "author"
  }, [_vm._v("Irene MacKay is Canadian but has been a resident of Switzerland for more than 40 years. She lives in an old farmhouse in the Jura Mountains together with her husband and 15 cats. Before retirement she worked as a teacher in international and national schools in Switzerland and Canada. She enjoys hiking and spending time in the wilderness of her natural garden, observing and learning to communicate with foxes, hedgehogs, martens, wild birds, plants and trees.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035842711_txt3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "c-heading"
  }, [_vm._v("Copyright © Irene MacKay 2024")]), _vm._v(" "), _c('p', {
    staticClass: "c-2nd ParaOverride-1"
  }, [_vm._v("Illustrated by Lara Gallagher")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("The right of "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Irene MacKay ")]), _vm._v("and"), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Lara Gallagher")]), _vm._v(" to be identified as author and illustrator of this work has been asserted by them in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("ISBN 9781035842711 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("ISBN 9781035842728 (Hardback)")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("ISBN 9781035842735 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("www.austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("Austin Macauley Publishers Ltd® ")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("1 Canada Square")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("Canary Wharf")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("E14 5AA")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "ded-next"
  }, [_vm._v("I would also like to thank anyone who has contributed to the publication in whatever shape or form to make my dream come true.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("I would like to dedicate Caterpillar’s Journey to the many, many students I have taught over the decades of my professional life. I would like to express my gratitude to Lara Gallagher, the gifted artist who illustrated Caterpillar’s Journey with amazing skill and great sensitivity.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035842711_txt6.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("Have I ever told you the story of a tiny white egg cradled on a juicy green leaf deep down in the forest? No? Well, then, let me tell it to you now. You see, eggs need to be kept warm so they can hatch. In my story, the sunshine keeps the egg warm and a gentle breeze sways it from side to side, just like a mama would cradle a baby. The animals of the forest look at the egg curiously. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“What do you think it is?” they ask each other but they all shake their heads – nobody knows.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035842711_txt8.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("But then suddenly, the little white egg starts to move and slowly, bit by bit, it cracks open. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“Oh!” say the animals in surprise and stare at the sweet, round face of a baby caterpillar appearing in the crack of the shell. Her shiny round eyes are full of wonder and curiosity as she pulls herself out. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“Welcome,” say the squirrels. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“My, you are sweet,” say the deer. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“Wonderful to meet you,” say the bumble bees. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("You see, that makes the little caterpillar feel welcome and loved. You probably know that caterpillars must eat a lot if they want to grow quickly, and this caterpillar certainly does. Taking big bites, she starts to crunch the juicy leaf on which she was born. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Between mouthfuls she tells the animals who are watching her: ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“This tastes very delicious.” ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Soon she has eaten the whole leaf and is looking for more because she is still very hungry.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035842711_txt10.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("So, you see, with all the eating, her small body becomes stronger, shiny and green with lovely little bristles and many tiny feet. The deer tell her that she looks adorable and the bumble bees want to play with her. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("How do I do that? Caterpillar thinks. How can I play with bumble bees? They can fly and I cannot. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("One day when she is too full of delicious food to eat more, she stops and sits down on a mossy tree stump to digest what is in her soft round belly. She gazes around and realises that she has never truly looked at the trees and plants of the forest. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("This is all so amazing and beautiful and the air smells so fresh and clean, she thinks to herself. Then she sees a big tree; it’s the tallest and it reaches right up into the blue above. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“What is so blue and wide and open up there that makes me feel so …” Caterpillar cannot find a word for how it makes her feel but she knows it touches her heart. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("That night when she looks up again, she sees sparkling lights way above, and she deeply wonders what they are. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“I must find out what this is about,” she tells the tree.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035842711_txt12.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("You can probably imagine why a short while later she decides to climb up the tall tree. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“I must find out what is beyond the very top.” ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("The bark of the tree is rough and difficult to climb. Looking up at the heavy old trunk she wonders, Oh, will I ever have the strength to get to the top? It is such a long way. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("And she is right, it takes all her will to pull herself up and over the many deep cracks in the bark. After a long while climbing she thinks, I am so tired and hungry. This is too hard for me. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Just then she hears the tree whisper, “Be still and strong like me and never forget that our mother, the earth, loves you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("The raindrops whisper, “Be like us and find your way back to the great ocean, nourishing all beings along the way.” ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“Let us bathe you in light and warmth,” say the sunbeams, “so your heart is always filled with love and joy.” ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("At night, the wind whispers the secrets of the forest and what lies beyond in the vast blue expanse above the trees. All these whisperings puzzle Caterpillar but to her surprise, fill her with hope too. Joyfully and with renewed energy she climbs on. Her longing to learn about the blue above is even stronger now because she is certain it will help her find what she is looking for.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035842711_txt14.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("But then, suddenly, everything stands still. Caterpillar no longer has the strength to move. With her last little bit of energy, she spins a thin silken thread with which to suspend herself from the highest branch of the tree. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("I feel so strange. Am I dreaming? She wonders. Slowly, her body turns into a chrysalis, gently swaying in the breeze. The inside of her body becomes caterpillar soup and all seems lost, just like in a dream …")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035842711_txt16.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("But wait! What you don’t know yet is that there is a magic spark hidden in the caterpillar soup. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“Don’t give up,” it whispers. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("This spark, you see, is very special because it longs to be touched by the golden light of the sun. Just then, one curious sunbeam sees a narrow crack in the chrysalis and instantly knows that it must get inside it. With all its might it pushes through the crack because it knows that this is what it is meant to do. And what do you know, the magic starts to work immediately, turning the caterpillar soup into a soft, furry body with glorious glittering wings, in the colours of the rainbow. Big curious eyes and quivering feelers appear on her head. Quickly, she realises that she is no longer a caterpillar. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“Now I know what I had felt all along – I was longing to become a butterfly because I must fly to be happy and free,” she tells herself.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035842711_txt18.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("Then a warm and gentle kiss from the sun shakes her out of her musing. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“Let me dry your wings till they shimmer and shine,” says the sun rising higher in the blue sky. Butterfly already knows in her heart what she must do now. Carefully, she spreads her beautiful wings and flies up into the eternal blue, along the golden path of the sun and into the vast expanse of the universe. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“I am free, I am free!” she calls joyfully to the forest way below her. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("All the animals look up, waving and smiling because they too share butterfly’s happiness and so do the trees.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("So, like all good tales this one too goes on and never really ends. Can you imagine why this is so? Can you find the secrets hidden in this story and why it can never end? Perhaps you can find the answers in your own dreams and longings … just like in the story about the caterpillar and the butterfly.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16908f80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled-1.vue
// module id = 57
// module chunks = 0